import { css, styled } from 'styled-components'

import { zIndexes } from '../../../theme/zIndexes'
import { IconButton } from '../Button/IconButton'

import { HeaderUser } from './User/HeaderUser'

export const StyledContainer = styled.header<{
  $variant: 'funnel' | 'user'
}>`
  position: fixed;
  z-index: ${zIndexes.header};
  top: 0;
  left: 0;
  display: grid;
  width: 100%;
  height: ${({ theme }) => theme.sizes.headerHeight}rem;
  align-items: center;
  padding: 0.5rem 1.25rem;
  background-color: ${({ theme }) => theme.colors['N Surface/Base']};

  ${({ $variant }) => {
    if ($variant === 'user') {
      return css`
        gap: 1rem;
        grid-template-areas: 'content user';
        grid-template-columns: auto 1fr;
      `
    }
    return css`
      gap: 0.5rem;
      grid-template-areas: 'button content side';
      grid-template-columns: 4rem 1fr 4rem;
    `
  }};
`

export const StyledIconButton = styled(IconButton)`
  grid-area: button;
`

export const StyledContent = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  grid-area: content;
`

export const StyledDevSlot = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const StyledHeaderUser = styled(HeaderUser)`
  display: flex;
  overflow: hidden;
  max-width: 100%;
  flex: 1;
  flex-direction: column;
  grid-area: user;
  justify-self: flex-end;
`
